import { CommonModule } from '@angular/common';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, EventEmitter, inject, Input, model, Output, signal, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CrudService } from 'src/app/core/services/crud.service';
import { QueryService } from 'src/app/core/services/query.service';
import { HttpClient } from '@angular/common/http';
import { WaterSupplyZoneService } from '../../water-supply-zone.service';
import { LayerGeografici } from '../../models/layer-geografici';

@Component({
  selector: 'app-input-select-string',
  standalone: true,
  imports: [MatFormFieldModule, MatChipsModule, MatIconModule, MatAutocompleteModule, FormsModule, ReactiveFormsModule, MatInputModule,CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './input-select-string.component.html',
  styleUrls: ['./input-select-string.component.css']
})
export class InputSelectStringComponent {
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly currentValue = model('');
  @ViewChild('luogoInput') luogoInput: any;
  @Input() title=''
  @Input() isDisabled:boolean=false
  @Input() datiSelezionati = signal<any[]>([]);
  @Input() allData: any[] = [];
  @Input() form!: FormGroup;
  @Input() name!: string;
  @Input() canAdd: boolean = true;
  @Input() placeholder: string = '';
  @Input() istatComune=''
  @Output() datiCercati = new EventEmitter<any>();
  @Output() removeDati = new EventEmitter<any>();
  //@Input() queryService!: QueryService<any>;
  //@Input() callBackFilterFunction:Function=()=>{}
  @Input() initialValue:any | undefined 
  filteredDatiSelezionati = signal<any[]>([]);

  readonly announcer = inject(LiveAnnouncer);

  constructor(private cdr: ChangeDetectorRef,private waterSupplyZoneService: WaterSupplyZoneService,  private http : HttpClient) {
    
  }

  ngOnInit() {

    this.filtereddatiSelezionati();
    if(this.initialValue){
      console.log(this.initialValue)
      this.datiSelezionati.set([this.initialValue[this.title]]);
      this.form.controls[this.name].setValue(this.initialValue[this.title])
      this.currentValue.set(this.initialValue[this.title])

   }

  }
   sleep(seconds:number) {
    return new Promise(resolve => setTimeout(resolve, seconds * 100));
  }
  
  filtereddatiSelezionati() {
    
    const currentValue = this.currentValue().toLowerCase();

    if (currentValue) {

      this.sleep(3).then(() => {
      //  this.queryService.get({ pageable: { size: 99999 }, filters: { 'generic.contains': currentValue } }, this.callBackFilterFunction(this.filteredDatiSelezionati, currentValue));

        this.waterSupplyZoneService.layerJsonWsz(0, 30, this.name, this.name!='comune' ? `proCom.IS=${this.istatComune}&${this.title}.LIKE=${currentValue}` : `${this.title}.LIKE=${currentValue}`).subscribe((el) => {
          console.log(el)
            const dati = el as LayerGeografici[];
            this.allData=dati
   
            this.filteredDatiSelezionati.set(this.allData.slice());
            this.cdr.detectChanges()
          });
      })
    } else {
      this.filteredDatiSelezionati.set(this.allData.slice());
    }

   
  }

  add(event: MatChipInputEvent): void {
    if (!this.canAdd) {
      return;
    }
    const value = (event.value || '').trim();

    if (value) {
 
      this.datiSelezionati.set([value]);
      this.form.controls[this.name].setValue(value)
    }

   // this.currentValue.set('');
    this.luogoInput.nativeElement.value = '';
    this.filteredDatiSelezionati.set(this.allData.slice());
    this.cdr.detectChanges();
  }

  remove(datoSelezionato: string): void {
    this.datiSelezionati.update(datiSelezionati => {
      const index = datiSelezionati.indexOf(datoSelezionato);
      if (index < 0) {
        return datiSelezionati;
      }
      console.log(datiSelezionati, this.allData)
      var datoFeature=this.allData.filter(el=>el.nome==datoSelezionato)
      if(datoFeature){
        this.removeDati.emit(datoFeature)
      }
    
      datiSelezionati.splice(index, 1);
      this.announcer.announce(`Removed ${datoSelezionato}`);
      this.form.controls[this.name].setValue('')
      return [...datiSelezionati];
    });

  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.datiSelezionati().includes(event.option.viewValue)) {

    //  this.currentValue.set('');
      this.luogoInput.nativeElement.value = '';
      this.filteredDatiSelezionati.set(this.allData.slice());
      this.form.controls[this.name].setValue(event.option.viewValue)
      event.option.deselect();
      this.cdr.detectChanges();
      return;
    }
    const elementAppoggio = this.datiSelezionati()

    elementAppoggio.push(event.option.viewValue)
    this.datiSelezionati.set(elementAppoggio);
    this.form.controls[this.name].setValue(event.option.viewValue)
   // this.currentValue.set('');
   // this.luogoInput.nativeElement.value = '';
   console.log(this.filteredDatiSelezionati())
    const elementoFiltrato = this.filteredDatiSelezionati().filter(el=>el[this.title]==event.option.viewValue && el[this.title]!='')
    if(elementoFiltrato.length>0){
      this.waterSupplyZoneService.geoJsonWsz(elementoFiltrato[0].id, this.name).subscribe(el=>{console.log(el);this.datiCercati.emit({
        geoJson : el,
        id:elementoFiltrato[0].id,
        nome: elementoFiltrato[0].nome,
        proCom: elementoFiltrato[0].proCom,
        nomeCampo: this.name,
      })})
    }
    this.filteredDatiSelezionati.set(this.allData.slice());
    event.option.deselect();
    this.cdr.detectChanges();
  }
}
